// extracted by mini-css-extract-plugin
module.exports = {"container_btn":"Pagina_container_btn__11Nvj","btn_page":"Pagina_btn_page__3uRpt","nextButtonProject":"Pagina_nextButtonProject__1HJVN"};